import React  from 'react';
import { debounce } from 'util/debounce';

/**
 * Use this hook to debounce functions safely inside a React component.
 */
export const useDebounce = (callback: (...arsg: unknown[]) => void, delay = 500) => {
  const callbackRef = React.useRef(callback);
  React.useLayoutEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(
    () => debounce((...args) => callbackRef.current(...args), delay),
    [delay],
  );
};
